import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { ToastrService } from "ngx-toastr";
import { CommanSubscribeService } from "./../../../../../core/services/comman-subscribe.service";
import { COLORLIST } from "./../../../../../core/constants";
import { API } from "aws-amplify";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CONST_AWS_API } from "src/app/core/constants";
import { Subscription } from "rxjs";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from "src/app/core/services/user.service";
import * as moment from "moment";
import { PubNubService } from "src/app/core/services/pubnub.service";
declare let $: any;

@Component({
  selector: "app-contacts",
  templateUrl: "./contacts.component.html",
  styleUrls: ["./contacts.component.scss"],
})
export class ContactsComponent implements OnInit {
  open: boolean;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  searchContact: any = "";
  searchContactsData: any;
  userColor: any = {};
  countUserColor = 0;
  content: string = "Contacts";
  showLoader: boolean = false;
  contactsList: any;
  name: any;
  redirectTo: any = "Contacts";
  //chat code starts
  isCheckingChannel: boolean = false;
  isChannelAvailable: boolean = false;
  channelHandler: any;
  openChannel: any;
  messageList: any = [];
  sendMessageText: any = "";
  contactData: any;
  groupChannel: any;
  isShowEmoji: boolean = false;
  toggleViewContact: boolean = false;
  isBlockContact: boolean = false;
  path: any;
  fansList: any = [];
  chatStatusSubscr: any;
  eventId: any;
  fansMsgData: any = [];
  msgCount: any = [];
  contactInfo: any;
  openPrivateChat: boolean = false;
  slugInfoSubscr: Subscription;
  slugInfo: any;
  updatedContactsList: any = [];
  receivedContactsList: any = [];
  sentContactsList: any = [];
  acceptedContactsList: any = [];
  assets_url = environment.assets_url;
  settingsDataSubscription: Subscription;
  settingsData: any = {};

  constructor(
    private userService: UserService,
    private ngxLoader: NgxUiLoaderService,
    public router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private commonSubscribeService: CommanSubscribeService,
    private pubnubService: PubNubService
  ) {}

  ngOnInit() {
    this.userInfo = this.commonSubscribeService.userInfo;
    let key = this.route.snapshot.params.ticket_key;
    this.eventId = key.split("-");
    this.userInfo.id =
      this.userInfo && this.userInfo.id ? this.userInfo.id : this.eventId[1];
    this.getContactsList();
    this.slugInfo = this.commonSubscribeService.slugInfo;
    this.slugInfoSubscr = this.commonSubscribeService
      .getSlugData()
      .subscribe((response) => {
        this.slugInfo = response;
      });

    this.userInfoSubscription = this.commonSubscribeService
      .getUserInfo()
      .subscribe((response) => {
        this.userInfo = response;
        this.getContactsList();
        this.connectToNotificationChannel();
      });
      this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
      this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
        this.settingsData = response;
        this.addStyle();
      })
  }

  addStyle(){
    document.documentElement.style.setProperty(
      '--tab-font-color',
      this.settingsData?.event_font_main_color
    );
    document.documentElement.style
    .setProperty('--event-private-chat-box', this.settingsData?.event_bg_primary_color);
  }

  isDataLoaded = false;
  getFansList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {},
    };
    let url = CONST_AWS_API.GET_FANS_BY_EVENT_ID + "/" + this.eventId[0];
    this.ngxLoader.start();
    API.get(environment.AWS_Cognito.apiName, url, data).then(
      (response) => {
        if (response.status == 200) {
          let fansList = response["data"]["Data"];
          this.commonSubscribeService.sendSlugData(
            response["data"]["stream_info"]
          );
          (this.fansList = []),
            (this.msgCount = []),
            (this.updatedContactsList = []),
            (this.receivedContactsList = []),
            (this.sentContactsList = []);
          fansList.forEach((e) => {
            if (e.user_id != this.userInfo.id) {
              e.userColor = this.getColor(e);
              e.shortName = this.getName(e.name);
              if (
                e.sent &&
                e.sent.indexOf(this.userInfo.id) != -1 &&
                e.accepted.indexOf(this.userInfo.id) == -1
              ) {
                this.fansList.unshift(e);
              } else if (e.accepted.indexOf(this.userInfo.id) != -1) {
                this.fansList.unshift(e);
              } else {
                this.fansList.push(e);
              }
              if (this.fansMsgData && this.fansMsgData.length > 0) {
                this.fansMsgData.forEach((data) => {
                  this.fansList.forEach((element) => {
                    if (element.user_id == data.user_id && data.messageReceived)
                      element.messageReceived = true;
                    else element.messageReceived = false;
                    if (element.messageReceived) this.msgCount.push(element);
                    this.userService.sendMessageStatus("Private Chat");
                  });
                });
              }
              this.ngxLoader.stop();
              if (e.sent.includes(this.userInfo.id)) {
                this.receivedContactsList.push(e);
              }
              if (e.received.includes(this.userInfo.id)) {
                this.sentContactsList.push(e);
              }
              if (this.contactsList && this.contactsList.length > 0) {
                this.contactsList.forEach((element) => {
                  if (
                    element.contactid == e.user_id &&
                    e.accepted.includes(this.userInfo.id)
                  ) {
                    this.updatedContactsList.push(element);
                  }
                });
              }
            }
          });
          this.isDataLoaded = true;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getContactsList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        userid: this.userInfo.id,
      },
    };
    API.post(
      environment.AWS_Cognito.apiName,
      CONST_AWS_API.GET_CONTACTS_LIST,
      data
    )
      .then((response) => {
        if (response.data.statusCode === "200") {
          this.contactsList = response["data"]["Data"];
          this.getFansList();
          this.contactsList.forEach((e) => {
            e.name = e.contact_details.name;
            e.contact_details.userColor = this.getColor(e);
            e.contact_details.shortName = this.getName(e.contact_details.name);
          });
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  getColor(contact, type?) {
    let id = contact.id ? contact.id : contact.contactid;
    id = type == "chat" ? contact._sender.userId : id;
    let color = "";
    if (!this.userColor[id]) {
      color = COLORLIST[this.countUserColor];
      this.userColor[id] = COLORLIST[this.countUserColor];
      if (this.countUserColor > COLORLIST.length) {
        this.countUserColor = 0;
      } else {
        this.countUserColor++;
      }
    } else {
      color = this.userColor[id];
    }
    return color;
  }

  getName(name) {
    let returnString = "";
    if (name) {
      let a = name.split(" ");
      if (a.length > 1) {
        returnString = a[0].charAt(0);
        returnString += a[1].charAt(0);
        return returnString;
      } else if (name) {
        returnString = a[0].charAt(0);
        returnString += a[0].charAt(1);
        return returnString;
      } else {
        return returnString;
      }
    }
  }

  connectToNotificationChannel(message?) {
    this.pubnubService.init();
    this.pubnubService.connect(
      this.userInfo && this.userInfo.id.toString(),
      (error) => {
        if (error) {
          this.isCheckingChannel = false;
          console.log("Error while connecting chat user", error);
          this.isChannelAvailable = false;
          // this.toastr.error("Error while connecting chat user");
          return;
        } else {
          this.pubnubService.enterChannel(
            "notifications",
            1,
            (openChannel, error) => {
              if (error) {
                this.isCheckingChannel = false;
                console.log("Error while connecting chat channel", error);
                this.isChannelAvailable = false;
                // this.toastr.error("Channel not available");
                return;
              }
              this.isCheckingChannel = true;
              this.isChannelAvailable = true;
              this.openChannel = openChannel;
              this.pubnubService.receiveMessages(
                "notifications",
                (response) => {
                  let membersList: any = [];
                  let channel = response.channel;
                  membersList = channel.members;
                  let message = response.message;
                  let receiverId;
                  if (message.data)
                    receiverId =
                      typeof message.data == "string"
                        ? JSON.parse(message.data)
                        : message.data;
                  if (
                    receiverId &&
                    receiverId.to &&
                    receiverId.to == this.userInfo.id
                  ) {
                    if (message._sender.userId) {
                      this.fansList.forEach((element) => {
                        if (
                          element.user_id == message._sender.userId ||
                          element.messageReceived
                        )
                          element.messageReceived = true;
                        else element.messageReceived = false;
                      });
                    }
                  } else {
                    membersList.forEach((mem) => {
                      this.fansList.forEach((element) => {
                        if (
                          mem.userId == element.user_id ||
                          element.messageReceived
                        )
                          element.messageReceived = true;
                        else element.messageReceived = false;
                        if (element.messageReceived)
                          this.msgCount.push(element);
                      });
                    });
                  }
                  this.fansMsgData = this.fansList;
                }
              );
            }
          );
        }
      }
    );
  }

  processContactRequest(contact, type) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        event_id: this.eventId[0],
        from: this.userInfo.id,
        to: contact.user_id,
        status: type,
      },
    };
    API.post(
      environment.AWS_Cognito.apiName,
      CONST_AWS_API.PROCESS_EVENT_CONTACT_REQUEST,
      data
    )
      .then((response) => {
        if (response.data.statusCode === "200") {
          let reqType = type == "accept" ? "accepted" : "rejected";
          this.toastr.success("Request is " + reqType);
          this.getContactsList();
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  blockContact(contact) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        userid: this.userInfo.id,
        contactid: contact.contactid ? contact.contactid : contact.user_id,
      },
    };
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.BLOCK_CONTACT, data)
      .then((response) => {
        if (response.data.statusCode === "200") {
          this.toastr.success("Contact blocked successfully");
          let text =
            this.router.url.includes("/stream/") ||
            this.router.url.includes("/event/schedule/")
              ? "Fans Online"
              : "Add Contact";

          this.searchContact = "";
          this.getContactsList();
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  tabClick(tab) {
    if (tab && tab.tab && tab.tab.textLabel) {
      this.searchContact = "";
      this.getContactsList();
    }
  }

  goToPrivateChat(contact) {
    this.router.navigateByUrl(
      `${this.commonSubscribeService.getBasePathFromUrl(this.router.url)}/event/private-chat/${this.route.snapshot.params.ticket_key}`
    );
    this.commonSubscribeService.sendContactInfo(contact);
  }

  ngOnDestroy() {
    this.pubnubService.disconnect(["notifications"]);
    if (this.slugInfoSubscr) this.slugInfoSubscr.unsubscribe();
    if (this.userInfoSubscription) this.userInfoSubscription.unsubscribe();
  }
}
